<template>
    <div class="chart-container">
        <Bar
            v-if="chartType === 'bar'"
            :data="chartData"
            :options="chartOptions"
        />
        <Line
            v-else-if="chartType === 'line'"
            :data="chartData"
            :options="chartOptions"
        />
        <Scatter
            v-else-if="chartType === 'scatter'"
            :data="chartData"
            :options="chartOptions"
        />
    </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { Line } from 'vue-chartjs'
import { Scatter } from 'vue-chartjs'

import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
} from 'chart.js'

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    BarElement,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale
)

export default {
    name: 'ChartComponent',
    components: {
        Bar,
        Line,
        Scatter,
    },
    computed: {
        chartData() {
            return {
                labels: this.labels,
                datasets: this.datasets,
            }
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                },
                ...this.options,
            }
        }
    },
    props: {
        chartType: {
            type: String,
            default: 'bar',
        },
        options: {
            type: Object,
            default: () => ({}),
        },
        labels: {
            type: Array,
            default: () => [],
        },
        datasets: {
            type: Array,
            default: () => [],
        },
    }
}
</script>

<style lang="scss" scoped>
.chart-container {
    height: 100%;
    width: 100%;
}
</style>
